export enum StepStatus {
    SUCCESS = 0,
    ERROR = 1,
    NO_STATUS = 2
}
